module.exports = __webpack_public_path__ + "static/zendesk-87ec5e1b71fbcd2840b21fea345b6a26.png";